import {Quote} from "../../api/models";
import React, {CSSProperties, useRef, useState} from "react";
import {Button, Popover} from "antd";
import TextArea from "antd/es/input/TextArea";
import Configurator from "../../pages/configurator";

const QuoteSalesRequestInput = (props:{
    quote:Quote | undefined
    readOnly?: boolean
    onChange?: (n: string | undefined) => void
    txtStyle?: CSSProperties
    btnStyle?: CSSProperties
}) => {

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const inputRef = useRef<any>(null);
    const txtStyle = {
        borderBottom: "1px solid black",
        ...props.txtStyle,
    };
    const [salesRequests, setSalesRequests] = useState<string>();

    const handleOpen = () => {
        setSalesRequests( props.quote?.salesRequests );
        setIsOpen(true);
    }
    const handleBlur = () => {

        setIsOpen(false);

        props.onChange?.( salesRequests );
    }

    const btnTitle = props.quote?.salesRequests ? props.quote?.salesRequests : "None";
    return <Popover
        trigger={"click"}
        afterOpenChange={(open) => {
            if( open ) {
                inputRef.current?.focus();
            }
        }}
        open={isOpen}
        content={<TextArea
            ref={inputRef}
            style={{width: "30rem"}}
            value={salesRequests}
            placeholder="Type Sales Request"
            onChange={(e) => setSalesRequests(e.target.value)}
            onBlur={handleBlur}
            onPressEnter={() => inputRef.current?.blur()}
            rows={4}
        /> }
        arrow={false}
    >
        {(!props.readOnly || props.quote?.salesRequests)
            ? <Button className="ghostBmButton" type="text" onClick={handleOpen}
                      title={btnTitle}
                      style={{
                          ...props.btnStyle,
                          margin: 0,
                          padding: 0
                      }} >
                <span style={txtStyle}>{btnTitle}</span>
            </Button>
            : btnTitle}
    </Popover>;
}

export default QuoteSalesRequestInput;

